module.exports = __webpack_public_path__ + "img/05.75700cb0.jpg";